import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu-light",
  "use": "icon-menu-light-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-menu-light\"><path d=\"M17 16H0v-2h17v2zm0-7H0V7h17v2zm0-7H0V0h17v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol